import "../Attractions/attractions.scss";
import image1 from "../assets/image/20211007_120244.jpg";
import { FaHouseDamage, FaTrash, FaRegEdit, FaMapMarkerAlt } from "react-icons/fa";
import { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import Loader from "utilities/Loader";
import { findRecord, sortArray } from "services/services";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import styles from "./attraction.module.css";
import ReactPaginate from "react-paginate";
import { getCities } from "admin-panel/create-tours/APIFunctions";
import WithAuthentication from "Authentication/AuthenticationContext";

export default function Attractions() {
  const auth = useContext(WithAuthentication);
  const [allItems, setAllItems] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updater, setUpdater] = useState(false);
  const [countPage, setCountPage] = useState(0);
  const [countAttraction, setCountAttraction] = useState([]);
  const [nameCities, setNameCities] = useState({ value: 0, label: "" });
  const [attrac, setAttrac] = useState({
    name: "",
    pic: null,
    desc: "",
  });

  let myAccessLevel = auth.userInfo.accessLevel;
  if (typeof myAccessLevel != "string") {
    myAccessLevel = myAccessLevel.toString();
  }
  myAccessLevel.split(",").find((value) => 6 == value);

  useEffect(() => {
    async function load() {
      let res = await findRecord("attractions", {
        fields: "COUNT(id) as count",
      });
    }
    load();
  }, []);
  useEffect(() => {
    let myFormData = new FormData();
    myFormData.append("count", 12);
    myFormData.append("page", 1);
    setIsLoading(true);
    axios
      .post("http://mvc.dade24.ir/api/Find_attractions", {
        data: myFormData,
      })
      .then(function (response) {
        let data = sortArray(response.data, "id");
        setAllItems(data);
        // setCountAttraction(data);
        let selectedCity = allOptions.find((value) => {
          return value.value == data.cityid;
        });
        if (typeof selectedCity === "undefined") {
          setNameCities({ value: 0, label: "" });
        } else {
          setNameCities(selectedCity);
        }
      })
      .catch(function (error) {});

    const getInfo = async () => {
      let data = await getCities().then((res) => res);
      let allCities = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allCities.push(newObject);
      }
      setAllOptions(allCities);
      setIsLoading(false);
    };
    getInfo();
  
  }, [updater]);

  // const items =(pageNum)=>{
  //   let myFormData = new FormData();
  //   myFormData.append("count", 12);
  //   myFormData.append("page", pageNum);
  //   setIsLoading(true);
  //   axios
  //     .post("http://mvc.dade24.ir/api/Find_attractions", {
  //       data: myFormData,
  //     })
  //     .then(function (response) {
  //       let data = sortArray(response.data, "id")
  //       setCountAttraction(data);
  //     })
  //     .catch(function (error) {});

  // }
  const inputRef = useRef();
  const animatedComponents = makeAnimated();
  const changeHandler = (e) => {
    setAttrac({ ...attrac, [e.target.name]: e.target.value });
  };
  const changeHandlerCities = (newValue, { action }) => {
    if (action == "create-option") {
      return setNameCities({ value: -1, label: newValue.label });
    }

    setNameCities(newValue);
  };
  const changeHandlerImg = (e) => {
    setAttrac({ ...attrac, [e.target.name]: e.target.files[0] });
  };

  var selectedCity = {};

  if (!allOptions.some((value) => value.value == nameCities.value)) {
    selectedCity = { id: -1, title: nameCities.label };
  } else {
    selectedCity = {
      id: nameCities.value,
      title: nameCities.label,
    };
  }
  if (selectedCity.title == undefined) {
    selectedCity.id = 0;
  }

  function postTour() {
    let myFormData = new FormData();
    myFormData.append("title", attrac.name);
    myFormData.append("cityid", selectedCity.id);
    myFormData.append("description", attrac.desc);
    myFormData.append("mainpic", attrac.pic);
    setIsLoading(true);
    axios.post("http://mvc.dade24.ir/api/Insert_attractions", myFormData).then(() => {
      inputRef.current.value = "";
      setAttrac({ name: "", pic: null, desc: "" });
      setNameCities({ value: 0, label: "" });
      setUpdater(!updater);
    });
  }

  function updateTour(attrac2, nameCities2) {
    let myFormData = new FormData();
    myFormData.append("conditions", `id/=/${attrac2.id}`);
    myFormData.append("keyvalues", `title,${attrac2.name2}@@description,${attrac2.desc2}@@mainpic,@@cityid,${nameCities2}`);
    myFormData.append("mainpic", attrac2.pic2);

    setIsLoading(true);

    axios.post("http://mvc.dade24.ir/api/Update_attractions", myFormData).then(() => {
      setUpdater(!updater);
    });
  }

  function deleteHandler(id) {
    let myFormData = new FormData();
    myFormData.append("conditions", `id/=/${id}`);
    axios.post(`http://mvc.dade24.ir/api/Delete_attractions`, myFormData);
    setUpdater(!updater);
  }

  return (
    <div className="bg-white m-4 rounded-3 Attractions" style={{ border: "2px solid gray" }}>
      {/* <!--Under-Head--> */}
      {isLoading && <Loader></Loader>}
      <div className="m-3">
        {myAccessLevel.split(",").find((value) => 6 == value) && (
          <button type="button" data-bs-toggle="modal" data-bs-target={`#add-modal`} className="btn" style={{ border: "1px solid #8c8b8b", borderRadius: "10px" }}>
            <span className="mt-2" style={{ fontWeight: "bold", fontSize: "20px", marginTop: "15px", marginLeft: "5px" }}>
              +
            </span>
            <span style={{ color: "#757373" }}>افزودن جاذبه </span>
          </button>
        )}
      </div>
      {/* <!--Title-Main--> */}
      <div className="title_main">
        <div className="title_main_text">
          <h4 style={{ fontFamily: IRANSans, fontWeight: "bold" }}>جاذبه های گردشگری</h4>
        </div>
        <div className="title_main_undertext">
          <FaHouseDamage className="house" />
        </div>
      </div>
      {/* {!isLoading && <Loader></Loader>} */}
      <div className="main_div" dir="ltr">
        {allItems?.map((value, index) => (
          <Attraction key={index} information={value} updateTour={updateTour} deleteHandler={deleteHandler} allOptions={allOptions} myAccessLevel={myAccessLevel} />
        ))}
      </div>

      <div className="modal fade" id={`add-modal`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 dir="rtl" className="modal-title" id="exampleModalLabel3">
                افزودن جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="dropdown_edit  m-2  w-100">
                  <label className="modal_label" for="gardeshgary_type_edit">
                    شهر
                  </label>

                  <CreatableSelect closeMenuOnSelect={true} components={animatedComponents} className={styles.filterSelect} isMulti={false} options={allOptions} value={nameCities} onChange={changeHandlerCities} />
                </div>

                <div className="inputname_edit positionedit m-2  w-100">
                  <label className="modal_label" for="inputname_edit_elder">
                    نام جاذبه
                  </label>
                  <input onChange={changeHandler} name="name" className="form-control w-100" value={attrac.name} type="text" id="inputname_edit_elder" />
                </div>

                <div className="inputimage_edit positionedit   w-100 m-2">
                  <label className="modal_label" for="img_edit">
                    عکس جاذبه
                  </label>
                  <div>
                    <input onChange={changeHandlerImg} ref={inputRef} name="pic" className="form-control" type="file" id="img_edit" accept="image/*" />
                  </div>
                </div>

                <div className="inputtextarea_edit positionedit  w-100  m-2">
                  <label className="modal_label" for="textarea_inputjazebe_edit">
                    توضیحات
                  </label>
                  <textarea onChange={changeHandler} value={attrac.desc} name="desc" className="form-control" id="textarea_inputjazebe_edit" cols="30" rows="4" style={{ resize: "none" }}></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                بستن
              </button>
              <button type="button" className="btn btn-primary btn-sm" data-bs-dismiss="modal" onClick={() => postTour()}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <ReactPaginate
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(allItems.length / 12)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={(e) => {
            console.log(e.selected)
            items(e.selected)
            
          }}
          containerClassName="pagination mb-3 padding-x"
          activeClassName=" style-activeClass"
          activeLinkClassName="bg-info text-white "
          pageClassName="style-pageClass mx-2"
          pageLinkClassName="page-link style-page-link"
          nextClassName="border btn mx-1 px-4 py-1 style-nextClass"
          previousClassName="border btn mx-1 px-4 py-1 style-previousClass "
          nextLinkClassName="style-nextLink "
          previousLinkClassName="style-previousLink "
        /> */}
    </div>
  );
}

const Attraction = ({ information, updateTour, deleteHandler, allOptions, myAccessLevel }) => {
  const [attrac2, setAttrac2] = useState({
    name2: information.title,
    pic2: information.mainpic,
    desc2: information.description,
    id: information.id,
  });
  const [nameCities2, setNameCities2] = useState({ value: 0, label: "" });
  const animatedComponents = makeAnimated();
  const changeHandler2 = (e) => {
    setAttrac2({ ...attrac2, [e.target.name]: e.target.value });
  };
  const changeHandlerImg2 = (e) => {
    setAttrac2({ ...attrac2, [e.target.name]: e.target.files[0] });
  };
  const changeHandlerCities2 = (newValue, { action }) => {
    if (action == "create-option") {
      return setNameCities2({ value: -1, label: newValue.label });
    }
    setNameCities2(newValue);
  };
  useEffect(() => {
    let x = allOptions.find((value) => {
      return value.value == information.cityid;
    });
    console.log(allOptions);
    if (typeof x !== "undefined") {
      setNameCities2(x);
    }
  }, []);
  return (
    <div className="panel1">
      <div className="m-3"></div>
      <div className="item_panel1 card" style={{ borderRadius: "12px" }}>
        <a className="item_panel_head1 card-header" href="#" style={{ background: "#303481", borderRadius: "8px" }}>
          <a style={{ color: "white" }}>{information.title}</a>
        </a>
        <div className="item_panel_body1 card-body">
          <a href="#">
            <img className="img-responsive" src={information.mainpic == "" ? image1 : "http://mvc.dade24.ir/" + information.mainpic} alt="mabad_hendoa"/>
          </a>
          <div className="tozihat d-flex" dir="rtl" style={{ textAlign: "right", fontSize: "12px", marginTop: "10px" }}>
            <span className="">
              <FaMapMarkerAlt />
            </span>
            <p className="font-regular ms-2">
              <strong>مکان:</strong>
              {nameCities2.label}
              <br />
              <div>
                <strong>شاخصه:</strong>

                <div
                  style={{
                    width: "100%",
                    height: "60px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: "3",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  <p style={{ fontSize: "13px" }}>{information.description}</p>
                </div>
              </div>
            </p>
          </div>

          {myAccessLevel.split(",").find((value) => 6 == value) && (
            <div>
              <button type="button" className="btnclose1" style={{ position: "absolute", left: "5px" }} data-bs-toggle="modal" data-bs-target={`#exampleModal2-${information.id}`}>
                <FaTrash />
              </button>
              <button type="button" className="btnedit1" style={{ position: "absolute", left: "25px" }} data-bs-toggle="modal" data-bs-target={`#edit-modal-${information.id}`}>
                <FaRegEdit />
              </button>
            </div>
          )}
        </div>
        <a className="item_panel_footer1 card-footer" href="#" style={{ background: "#303481", color: "white", textAlign: "center", borderRadius: "8px" }}>
          نوع جاذبه:
          <a style={{ color: "white" }}> دیدنی های سراسر دنیا </a>
        </a>
      </div>

      <div className="modal fade" id={`edit-modal-${information.id}`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div dir="rtl" className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel3">
                ویرایش جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="dropdown_edit  m-2  w-100">
                  <label className="modal_label" for="gardeshgary_type_edit">
                    شهر
                  </label>

                  <CreatableSelect closeMenuOnSelect={true} components={animatedComponents} className={styles.filterSelect} isMulti={false} options={allOptions} value={nameCities2} onChange={changeHandlerCities2} />
                </div>
                <div className="inputname_edit positionedit m-2  w-100">
                  <label className="modal_label" for="inputname_edit_elder">
                    نام جاذبه
                  </label>
                  <input onChange={changeHandler2} name="name2" className="form-control w-100" type="text" id="inputname_edit_elder" defaultValue={information.title} />
                </div>

                <div className="inputimage_edit positionedit   w-100 m-2">
                  <label className="modal_label" for="img_edit">
                    عکس جاذبه
                  </label>
                  <div>
                    <input onChange={changeHandlerImg2} name="pic2" className="form-control" type="file" id="img_edit" accept="image/*" />
                  </div>
                </div>

                <div className="inputtextarea_edit positionedit  w-100  m-2">
                  <label className="modal_label" for="textarea_inputjazebe_edit">
                    توضیحات
                  </label>
                  <textarea onChange={changeHandler2} name="desc2" className="form-control" id="textarea_inputjazebe_edit" cols="30" rows="4" style={{ resize: "none" }} defaultValue={information.description}></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                data-bs-dismiss="modal"
                onClick={() => {
                  updateTour(attrac2, nameCities2);
                }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <!--Modal Trash--> */}
      <div className="modal fade" id={`exampleModal2-${information.id}`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{ justifyContent: "end" }}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                حذف جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body modlatrashposition">
              <p>آیا جاذبه مد نظر حذف شود؟</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                خیر
              </button>
              <button
                type="button"
                onClick={() => {
                  deleteHandler(information.id);
                }}
                className="btn btn-danger btn-sm"
                data-bs-dismiss="modal"
              >
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <!--Modal Edit--> */}
    </div>
  );
};
// http://mvc.dade24.ir/api/Find_cities
